export default __webpack_public_path__ + "static/media/bg-character.e5094c92.jpg";